// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviewsContainer_bey5U {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  align-items: center;
  width: 100vw;
}
.reviewsSection_TBer3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

@media (width <= 500px) {
  .reviewsSection_TBer3 {
    margin-top: 40px;
  }
}
.startNowSection_DuBfF {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 50px;
  height: fit-content !important;
  min-height: 40vh !important;
}
.reviewsTitle_sK8hB {
  font-size: clamp(20px, 5vw, 40px) !important; 
  font-weight: 400;
  color: #18181b;
  text-align: center;
  margin: 0;
}

.CarrouselContainer_QUhM_ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;
  height: 100vh;
}



.reviewsDescriptionLast_bUBtw {
  color: #676767;
  font-size: clamp(17px, 5vw, 20px) !important;
  font-weight: 300;
  text-align: center;
  padding: 0 20px;
  margin: 0;
}
.startsFrom_fuRhn {
  font-weight: 700;
  font-size: 36px;
  color: var(--_10a37f-background);
  display: flex;
  gap: 10px;
  margin-top: 25px;
  div {
    display: flex;
    gap: 10px;
  }
  span {
    color: black;
  }
  span:first-child {
    font-weight: 300;
  }
}
@media (width <= 370px) {
  .startsFrom_fuRhn {
    flex-direction: column;
  }
}
.price_SZ7E9 {
  font-size: clamp(30px, 12vw, 86px) !important; 
  color: #18181b;
  font-weight: 700;
  margin-bottom: 20px;
  span {
    margin-left: -10px;
    font-size: 46px;
  }
}


.startButton_J3uxL {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: var(--white-background);
  font-size: 18px;
  font-weight: 400;
  background: var(--_10a37f-background);
  width: 100%;
  min-width: 200px;
  max-width: fit-content;
  padding: 4px 8px;
  height: 57px;
  min-height: 57px;
  text-decoration: none;
  gap: 15px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  text-wrap: nowrap;
  img {
    height: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Reviews/Reviews.module.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,aAAa;AACf;;;;AAIA;EACE,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,6CAA6C;EAC7C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB;IACE,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap\");\n.reviewsContainer {\n  display: flex;\n  flex-direction: column;\n  font-family: \"Inter\", sans-serif;\n  align-items: center;\n  width: 100vw;\n}\n.reviewsSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n@media (width <= 500px) {\n  .reviewsSection {\n    margin-top: 40px;\n  }\n}\n.startNowSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 10px;\n  margin-bottom: 50px;\n  height: fit-content !important;\n  min-height: 40vh !important;\n}\n.reviewsTitle {\n  font-size: clamp(20px, 5vw, 40px) !important; \n  font-weight: 400;\n  color: #18181b;\n  text-align: center;\n  margin: 0;\n}\n\n.CarrouselContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: 20px;\n  height: 100vh;\n}\n\n\n\n.reviewsDescriptionLast {\n  color: #676767;\n  font-size: clamp(17px, 5vw, 20px) !important;\n  font-weight: 300;\n  text-align: center;\n  padding: 0 20px;\n  margin: 0;\n}\n.startsFrom {\n  font-weight: 700;\n  font-size: 36px;\n  color: var(--_10a37f-background);\n  display: flex;\n  gap: 10px;\n  margin-top: 25px;\n  div {\n    display: flex;\n    gap: 10px;\n  }\n  span {\n    color: black;\n  }\n  span:first-child {\n    font-weight: 300;\n  }\n}\n@media (width <= 370px) {\n  .startsFrom {\n    flex-direction: column;\n  }\n}\n.price {\n  font-size: clamp(30px, 12vw, 86px) !important; \n  color: #18181b;\n  font-weight: 700;\n  margin-bottom: 20px;\n  span {\n    margin-left: -10px;\n    font-size: 46px;\n  }\n}\n\n\n.startButton {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  color: var(--white-background);\n  font-size: 18px;\n  font-weight: 400;\n  background: var(--_10a37f-background);\n  width: 100%;\n  min-width: 200px;\n  max-width: fit-content;\n  padding: 4px 8px;\n  height: 57px;\n  min-height: 57px;\n  text-decoration: none;\n  gap: 15px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  text-wrap: nowrap;\n  img {\n    height: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reviewsContainer": `reviewsContainer_bey5U`,
	"reviewsSection": `reviewsSection_TBer3`,
	"startNowSection": `startNowSection_DuBfF`,
	"reviewsTitle": `reviewsTitle_sK8hB`,
	"CarrouselContainer": `CarrouselContainer_QUhM_`,
	"reviewsDescriptionLast": `reviewsDescriptionLast_bUBtw`,
	"startsFrom": `startsFrom_fuRhn`,
	"price": `price_SZ7E9`,
	"startButton": `startButton_J3uxL`
};
export default ___CSS_LOADER_EXPORT___;
